import { cn } from "@/lib/utils"

const SOURCES = {
  wordmark: {
    light: "/images/logo/flywrite.png",
    dark: "/images/logo/flywrite-dark.png",
  },
  icon: {
    light: "/images/logo/flywrite-icon.png",
    dark: "/images/logo/flywrite-icon-dark.png",
  },
}

// Official Flywrite logo (PNG chips in public/images/logo/). Two variants:
// the full wordmark (458×132) and the square "#" icon (132×132, for tight
// spots like the collapsed sidebar rail). Theme-aware: renders the
// light-background version in light mode and the dark-background version in
// dark mode. Size it with a height utility via className (defaults to h-8);
// width follows the image's aspect ratio.
export function Logo({
  variant = "wordmark",
  className,
}: {
  variant?: "wordmark" | "icon"
  className?: string
}) {
  const src = SOURCES[variant]
  return (
    <>
      <img
        src={src.light}
        alt="Flywrite"
        className={cn("h-8 w-auto dark:hidden", className)}
      />
      <img
        src={src.dark}
        alt="Flywrite"
        className={cn("hidden h-8 w-auto dark:block", className)}
      />
    </>
  )
}
